/*

document.addEventListener("DOMContentLoaded", function() {
  var video = jQuery('.js-page-about .js-bg-container .js-video')[0];

  var isPlaying = false;
  
  function playSegment({ start, end }) {
    video.currentTime = start;
    video.play();

    if(isPlaying){
      video.removeEventListener('timeupdate', stopAt);
    }
    isPlaying = true;
  
    const stopAt = () => {
      if (video.currentTime >= end) {
        video.pause();
        video.removeEventListener('timeupdate', stopAt);
        isPlaying = false;
      }
    };
  
    video.addEventListener('timeupdate', stopAt);
  }
  
  playSegment({start: 0, end: 2});

  ScrollTrigger.create({
    trigger: ".js-video-checkpoint",
    start: () => 'top center',
    end: () => 'bottom-=25% center',
    markers: true,
    onEnter: () => {
      playSegment({start: 2, end: 8});
    },
    onLeave: () => {
      playSegment({start: 8, end: 12})
    }
  })
});
*/



document.addEventListener("DOMContentLoaded", function() {
  var renderWidth = 1920;
  var renderHeight = 1080;

  var s1_buffer = [];
  var s2_buffer = [];
  var s3_buffer = [];
  var s4_buffer = [];

  var a1_init = 0;
  var s1_loaded = 0;
  var s1_length = 124;
  var s1 = [];

  var a2_init = 0;
  var s2_loaded = 0;
  var s2_length = 191;
  var s2 = [];

  var a3_init = 0;
  var s3_loaded = 0;
  var s3_length = 190;
  var s3 = [];

  var a4_init = 0;
  var s4_loaded = 0;
  var s4_length = 198;
  var s4 = [];


  var s1_mobile_loaded = 0;
  var s1_mobile_length = 133;
  var s1_mobile = [];

  var s2_mobile_loaded = 0;
  var s2_mobile_length = 144;
  var s2_mobile = [];

  var s3_mobile_loaded = 0;
  var s3_mobile_length = 228;
  var s3_mobile = [];

  var s4_mobile_loaded = 0;
  var s4_mobile_length = 151;
  var s4_mobile = [];

  
  var $bg_container = jQuery('.js-bg-container');
  var $canvas = jQuery('.js-canvas');
  var canvas = $canvas[0];
  var ctx = canvas.getContext('2d');

  var currentFrame = null;

  canvas.width = renderWidth;
  canvas.height = renderHeight;

  function load_s1(){
    for(var i = 0; i < s1_length; i++){
      var image = new Image();
      image.src = "https://cdn.shopify.com/s/files/1/0938/0148/0457/files/s_1_" + i + ".webp";
      image.onload = () => {
        s1_loaded++;
        if (s1_loaded === s1_length) {
          console.log('Tutte le immagini caricate');

          if(!a1_init)
            init_s1_animation();
        }
      };
      s1.push(image);
    }
    
    s1_buffer = s1;
  }

  function load_s2(){
    for(var i = 0; i < s2_length; i++){
      var image = new Image();
      image.src = "https://cdn.shopify.com/s/files/1/0938/0148/0457/files/s_2_" + i + ".webp";
      image.onload = () => {
        s2_loaded++;
        if (s2_loaded === s2_length) {
          console.log('Tutte le immagini caricate');

          if(!a2_init)
            init_s2_animation();
        }
      };
      s2.push(image);
    }

    s2_buffer = s2;
  }

  function load_s3(){
    for(var i = 0; i < s3_length; i++){
      var image = new Image();
      image.src = "https://cdn.shopify.com/s/files/1/0938/0148/0457/files/s_3_" + i + ".webp";
      image.onload = () => {
        s3_loaded++;
        if (s3_loaded === s3_length) {
          console.log('Tutte le immagini caricate');

          if(!a3_init)
            init_s3_animation();
        }
      };
      s3.push(image);
    }

    s3_buffer = s3;
  }

  function load_s4(){
    for(var i = 0; i < s4_length; i++){
      var image = new Image();
      image.src = "https://cdn.shopify.com/s/files/1/0938/0148/0457/files/s_4_" + i + ".webp";
      image.onload = () => {
        s4_loaded++;
        if (s4_loaded === s4_length) {
          console.log('Tutte le immagini caricate');

          if(!a4_init)
            init_s4_animation();
        }
      };
      s4.push(image);
    }

    s4_buffer = s4;
  }

  function load_s1_mobile(){
    for(var i = 0; i < s1_mobile_length; i++){
      var image = new Image();
      image.src = "https://cdn.shopify.com/s/files/1/0938/0148/0457/files/s_1_mobile_" + i + ".webp";
      image.onload = () => {
        s1_mobile_loaded++;
        if (s1_mobile_loaded === s1_mobile_length) {
          console.log('Tutte le immagini caricate');

          if(!a1_init)
            init_s1_animation();
        }
      };
      s1_mobile.push(image);
    }

    s1_buffer = s1_mobile;
  }

  function load_s2_mobile(){
    for(var i = 0; i < s2_mobile_length; i++){
      var image = new Image();
      image.src = "https://cdn.shopify.com/s/files/1/0938/0148/0457/files/s_2_mobile_" + i + ".webp";
      image.onload = () => {
        s2_mobile_loaded++;
        if (s2_mobile_loaded === s2_mobile_length) {
          console.log('Tutte le immagini caricate');

          if(!a2_init)
            init_s2_animation();
        }
      };
      s2_mobile.push(image);
    }

    s2_buffer = s2_mobile;
  }

  function load_s3_mobile(){
    for(var i = 0; i < s3_mobile_length; i++){
      var image = new Image();
      image.src = "https://cdn.shopify.com/s/files/1/0938/0148/0457/files/s_3_mobile_" + i + ".webp";
      image.onload = () => {
        s3_mobile_loaded++;
        if (s3_mobile_loaded === s3_mobile_length) {
          console.log('Tutte le immagini caricate');
          
          if(!a3_init)
            init_s3_animation();
        }
      };
      s3_mobile.push(image);
    }

    s3_buffer = s3_mobile;
  }

  function load_s4_mobile(){
    for(var i = 0; i < s4_mobile_length; i++){
      var image = new Image();
      image.src = "https://cdn.shopify.com/s/files/1/0938/0148/0457/files/s_4_mobile_" + i + ".webp";
      image.onload = () => {
        s4_mobile_loaded++;
        if (s4_mobile_loaded === s4_mobile_length) {
          console.log('Tutte le immagini caricate');

          if(!a4_init)
            init_s4_animation();
        }
      };
      s4_mobile.push(image);
    }

    s4_buffer = s4_mobile;
  }
  

  // s1 animation
  function init_s1_animation(){
    a1_init = 1;
    ScrollTrigger.create({
      trigger: '.js-sequence-1',
      start: () => 'top top',
      end: () => 'bottom center',
      // markers: true,
      onUpdate: (self) => {
        var index = parseInt(Math.floor(s1_buffer.length * self.progress));
        if(index < s1_buffer.length){
          drawFrame(s1_buffer[index]);
        }
      }
    }) 
  }

  function init_s2_animation(){
    a2_init = 1;
    ScrollTrigger.create({
      trigger: '.js-sequence-2',
      start: () => 'center center',
      end: () => 'bottom+=25% center',
      // markers: true,
      onUpdate: (self) => {
        var index = parseInt(Math.floor(s2_buffer.length * self.progress));
        if(index < s2_buffer.length){
          drawFrame(s2_buffer[index]);
        }
      }
    }) 
  }

  function init_s3_animation(){
    a3_init = 1;
    ScrollTrigger.create({
      trigger: '.js-sequence-3',
      start: () => 'top center',
      end: () => 'bottom+=10% center',
      // markers: true,
      onUpdate: (self) => {
        var index = parseInt(Math.floor(s3_buffer.length * self.progress));
        if(index < s3_buffer.length){
          drawFrame(s3_buffer[index]);
        }
      }
    })

    gsap.registerPlugin(ScrollTrigger);
    
    gsap.fromTo('.js-sequence-3-out .js-opacity-animation', {
      opacity: 0,
    }, {
      opacity: 1,
      scrollTrigger: {
        trigger: '.js-sequence-3-out',
        start: () => 'top center',
        end: () => '+=300px',
        // markers: true,
        scrub: true,
      },
    })
  }

  function init_s4_animation(){
    a4_init = 1;
    ScrollTrigger.create({
      trigger: '.js-sequence-4',
      start: () => 'top-=10% center',
      end: () => 'bottom-=10% center',
      // markers: true,
      onUpdate: (self) => {
        var index = parseInt(Math.floor(s4_buffer.length * self.progress));
        if(index < s4_buffer.length){
          drawFrame(s4_buffer[index]);
        }
      },
      onLeave: () => {
        $bg_container.addClass('hidden');
        /*
        console.log("onleave");
        gsap.timeline()
        .to($bg_container, {
          opacity: 0,
          duration: 2
        })
        .set($bg_container, {
          display: 'none'
        })
        */
      },
      onEnterBack: () => {
        $bg_container.removeClass('hidden');
        /*
        gsap.timeline()
        .set($bg_container, {
          display: 'block'
        })
        .to($bg_container, {
          opacity: 1,
          duration: 1
        })
        */
      }
    }) 

    gsap.registerPlugin(ScrollTrigger);
    
    gsap.fromTo('.js-sequence-4 .js-opacity-animation', {
      opacity: 0,
    }, {
      opacity: 1,
      scrollTrigger: {
        trigger: '.js-sequence-4',
        start: () => 'center+=250px center',
        end: () => '+=300px',
        // markers: true,
        scrub: true,
      },
    })
  }
  

  var drawFrame = function(frame) {
    currentFrame = frame;
    var offsetX = (canvas.width - renderWidth) / 2;
    var offsetY = (canvas.height - renderHeight) / 2;

    ctx.clearRect(offsetX, offsetY, renderWidth, renderHeight);
    ctx.drawImage(frame, offsetX, offsetY, renderWidth, renderHeight);
  }

  var drawFrameMobileFocused = function(frame) {
    if (!frame) return;
    
    currentFrame = frame;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    var WW = jQuery(window).width();
    var WH = jQuery(window).height();
    
    if (WW <= 1215) {
      // Mobile: scala per coprire tutto lo schermo mantenendo le proporzioni
      var scale = Math.max(WW / renderWidth, WH / renderHeight);
      
      var scaledWidth = renderWidth * scale;
      var scaledHeight = renderHeight * scale;
      
      // Centra l'immagine
      var offsetX = (WW - scaledWidth) / 2;
      var offsetY = (WH - scaledHeight) / 2;
      
      ctx.drawImage(frame, offsetX, offsetY, scaledWidth, scaledHeight);
    } else {
      // Desktop: scala per fit completo
      var scale = Math.max(WW / renderWidth, WH / renderHeight);
      
      var scaledWidth = renderWidth * scale;
      var scaledHeight = renderHeight * scale;
      var offsetX = (WW - scaledWidth) / 2;
      var offsetY = (WH - scaledHeight) / 2;
      
      ctx.drawImage(frame, offsetX, offsetY, scaledWidth, scaledHeight);
    }
  }
  drawFrame = drawFrameMobileFocused;


  function lazyload_s3_s4(){
    if(jQuery(window).width() > 1215){
      load_s3();
      load_s4();
    }else{
      load_s3_mobile();
      load_s4_mobile();
    }
  }

  
  if(jQuery(window).width() > 1215){
      load_s1();
      load_s2();
  }
  

  let mm = gsap.matchMedia();
  mm.add('(max-width: 1215px)', function(){
    renderWidth = 1080;
    renderHeight = 1920;
    canvas.width = renderWidth;
    canvas.height = renderHeight;
    
    if(s1_mobile_loaded == 0){
      load_s1_mobile();
      load_s2_mobile();
    }else{
      s1_buffer = s1_mobile;
      s2_buffer = s2_mobile;
    }

    /*
    if(s3_mobile_loaded == 0){
      load_s3_mobile();
      load_s4_mobile();
    }else{
      s3_buffer = s3_mobile;
      s4_buffer = s4_mobile;
    }
    */
    
    return () => {
      renderWidth = 1920;
      renderHeight = 1080;
      canvas.width = renderWidth;
      canvas.height = renderHeight;
      
      if(s1_loaded == 0){
        load_s1();
        load_s2();
      }else{
        s1_buffer = s1;
        s2_buffer = s2;
      }

      if(s3_loaded == 0){
        load_s3();
        load_s4();
      }else{
        s3_buffer = s3;
        s4_buffer = s4;
      }
    }
  });


  ScrollTrigger.create({
    trigger: '.js-sequence-2',
    start: 'top bottom',
    // markers:  true,
    once: true,
    onEnter: () => {
      lazyload_s3_s4();
    }
  });



  function onResize(){
    var WW = jQuery(window).width();
    var WH = jQuery(window).height();
    
    // Il canvas dovrebbe sempre occupare tutta la finestra
    canvas.width = WW;
    canvas.height = WH;
    
    // Ridisegna il frame corrente se esiste
    if(currentFrame){
      drawFrame(currentFrame);
    }
  }
  onResize();

  window.addEventListener('resize', function(){
    onResize();
  })
})